// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-03fabd5c] .current-row td{background-color:#d4e2ed!important}", ""]);
// Exports
module.exports = exports;
